import React, { useContext, useState, useEffect } from 'react';
import { ShopContext } from '../context/shopcontext';
import ProductItem from './ProductItem';
import axios from 'axios';

const BestSeller = () => {
  const { backendUrl } = useContext(ShopContext);
  const [bestSeller, setBestSeller] = useState([]);

  const categories = ['Necklace', 'Bangle', 'Harams', 'Earrings'];

  useEffect(() => {
    const cached = sessionStorage.getItem('bestSellers');
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed) && parsed.length > 0) {
          setBestSeller(parsed);
          return;
        }
      } catch {
        sessionStorage.removeItem('bestSellers');
      }
    }

    const fetchAllBestsellers = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/product/list?bestseller=true&limit=8`);
        const products = response.data?.products || [];

        const unique = [];
        const seen = new Set();

        for (let product of products) {
          if (!seen.has(product._id)) {
            seen.add(product._id);
            unique.push(product);
          }
        }

        const shuffled = unique.sort(() => 0.5 - Math.random());
        const evenCount =
          shuffled.length % 2 === 0 ? shuffled : shuffled.slice(0, shuffled.length - 1);

        setBestSeller(evenCount);
        sessionStorage.setItem('bestSellers', JSON.stringify(evenCount));
      } catch (err) {
        console.error('Error fetching bestsellers:', err);
      }
    };

    fetchAllBestsellers();
  }, [backendUrl]);

  return (
    <section className="bg-[#2a081a] text-[#ebe2db] p-4 sm:px-10">
      {/* Heading */}
      <div className="text-center mb-10">
        <h2 className="text-3xl sm:text-4xl font-cinzelDecorative tracking-wider text-[#e0c3b5]">
          Best Sellers
        </h2>
        <p className="text-sm sm:text-base text-[#b09287] italic mt-2">
          Loved and trusted by hundreds of style-conscious customers.
        </p>
        <div className="mt-4 mx-auto w-24 h-1 bg-[#b09287] rounded-full" />
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-1 sm:gap-6">
        {bestSeller.length > 0 ? (
          bestSeller.map((item) => (
            <ProductItem
              key={item._id}
              id={item._id}
              name={item.name}
              image={item.image}
              price={item.price}
              rating={item.averageRating || 0}
              totalReviews={item.totalReviews}
              bestseller={item.bestseller}
              inStock={item.inStock}
              category={item.category}
              subCategory={item.subCategory}
              sizes={item.sizes}
              stockQuantity={item.stockQuantity}
              currentPage={1}
              categoryFilter={[]}
              subCategoryFilter={[]}
              sortType={'relevant'}
              pageKey={'home'}
              restock={item.restock}
            />
          ))
        ) : (
          <div className="col-span-full text-center text-[#b09287] py-6">
            No bestsellers available at the moment.
          </div>
        )}
      </div>

      <div className="mt-12 h-px bg-[#b09287]/30" />
    </section>
  );
};

export default BestSeller;
